import React from 'react';
import { useParams } from 'react-router-dom';

function MapPage() {
    const { slug } = useParams();
    return (
        <div style={{ padding: '50px', textAlign: 'center' }}>
            <h1>🗺️ Página de Mapa Dinámico ({slug?.toUpperCase()})</h1>
            <p>Este componente contendrá el mapa centrado en {slug}.</p>
        </div>
    );
}

export default MapPage;